import PreLoadingResetSignaturePositioningScreen from "@/views/core/extranet/transactions/positioning/PreLoadingResetSignaturePositioningScreen";
import AuthLayout from "@components/core/routes/AuthLayout";
import EnvironmentLayout from "@components/core/routes/EnvironmentLayout";
import { ROUTES } from "@routes/Routes";
import LoginScreen from "@views/core/auth/login/LoginScreen";
import LogoutScreen from "@views/core/auth/logout/LogoutScreen";
import CookiesScreen from "@views/core/cookie/CookiesScreen";
import SelectUserScreen from "@views/core/e2e/users/SelectUserScreen";
import Error404Screen from "@views/core/error404/Error404Screen";
import CguScreen from "@views/core/extranet/cgu/CguScreen";
import EditorTokenCallbackScreen from "@views/core/extranet/editors/EditorTokenCallbackScreen";
import ErrorScreen from "@views/core/extranet/error/ErrorScreen";
import HomeScreen from "@views/core/extranet/home/HomeScreen";
import MyInformationsScreen from "@views/core/extranet/menu/account/myInformations/MyInformationsScreen";
import MyPreferencesScreen from "@views/core/extranet/menu/account/myPreferences/MyPreferencesScreen";
import MySignatureScreen from "@views/core/extranet/menu/account/mySignature/MySignatureScreen";
import BalanceAndStatisticsScreen from "@views/core/extranet/menu/offices/balanceAndStatistics/BalanceAndStatisticsScreen";
import ContactsScreen from "@views/core/extranet/menu/offices/contacts/ContactsScreen";
import GroupScreen from "@views/core/extranet/menu/offices/group/GroupScreen";
import MailModelScreen from "@views/core/extranet/menu/offices/mailModels/details/MailModelScreen";
import MailModelsScreen from "@views/core/extranet/menu/offices/mailModels/MailModelsScreen";
import OfficeScreen from "@views/core/extranet/menu/offices/office/OfficeScreen";
import PreferencesScreen from "@views/core/extranet/menu/offices/preferences/PreferencesScreen";
import TransactionModelScreen from "@views/core/extranet/menu/offices/transactionModels/details/TransactionModelScreen";
import ModelSignaturePositioningScreen from "@views/core/extranet/menu/offices/transactionModels/positioning/ModelSignaturePositioningScreen";
import TransactionModelsScreen from "@views/core/extranet/menu/offices/transactionModels/TransactionModelsScreen";
import UsersScreen from "@views/core/extranet/menu/offices/users/UsersScreen";
import OfficeTransferCanceledScreen from "@views/core/extranet/officeTransfer/canceled/OfficeTransferCanceledScreen";
import OfficeTransferScreen from "@views/core/extranet/officeTransfer/confirmation/OfficeTransferScreen";
import OfficeTransferConfirmedScreen from "@views/core/extranet/officeTransfer/confirmed/OfficeTransferConfirmedScreen";
import OfficeTransferRefusedScreen from "@views/core/extranet/officeTransfer/refused/OfficeTransferRefusedScreen";
import OnboardingScreen from "@views/core/extranet/onboarding/OnboardingScreen";
import SignatorySignatureSuccessScreen from "@views/core/extranet/signature/SignatorySignatureSuccessScreen";
import TransactionScreen from "@views/core/extranet/transactions/details/TransactionScreen";
import SignaturePositioningScreen from "@views/core/extranet/transactions/positioning/SignaturePositioningScreen";
import ProcessScreen from "@views/core/extranet/transactions/process/ProcessScreen";
import ScellementScreen from "@views/core/extranet/transactions/scellement/ScellementScreen";
import SignatureScreen from "@views/core/extranet/transactions/signature/SignatureScreen";
import MaintenanceScreen from "@views/core/maintenance/MaintenanceScreen";
import { Navigate, Route } from "react-router-dom";

const coreRoutes = (
  <>
    <Route path="*" element={<Error404Screen />} />
    <Route path={ROUTES.auth.login.generate()} element={<LoginScreen />} />
    <Route path={ROUTES.auth.logout.generate()} element={<LogoutScreen />} />
    <Route path={ROUTES.cookie.generate()} element={<CookiesScreen />} />

    <Route
      element={
        <EnvironmentLayout allowedEnvironments={["e2e", "integration"]} />
      }
    >
      <Route
        path={ROUTES.e2e.users.generate()}
        element={<SelectUserScreen />}
      />
    </Route>

    <Route
      path={ROUTES.maintenance.generate()}
      element={<MaintenanceScreen />}
    />
    <Route path={ROUTES.error404.generate()} element={<Error404Screen />} />

    <Route element={<AuthLayout />}>
      <Route path={ROUTES.extranet.home.generate()} element={<HomeScreen />} />
      <Route
        path={ROUTES.extranet.onboarding.generate()}
        element={<OnboardingScreen key="onboarding" />}
      />
      <Route
        path={ROUTES.extranet.onboardingStatus.generate(":status")}
        element={<OnboardingScreen key="status" />}
      />
      <Route
        path={ROUTES.extranet.menu.account.myInformations.generate()}
        element={<MyInformationsScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.account.mySignature.generate()}
        element={<MySignatureScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.account.myPreferences.generate()}
        element={<MyPreferencesScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.office.generate()}
        element={<OfficeScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.balanceAndStatistics.generate(
          ":officeId",
        )}
        element={<BalanceAndStatisticsScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.transactionModel.list.generate()}
        element={<TransactionModelsScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.transactionModel.signature.generate()}
        element={<TransactionModelScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.transactionModel.scellement.generate()}
        element={<TransactionModelScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.transactionModel.positioning.generate()}
        element={<ModelSignaturePositioningScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.mailModel.list.generate()}
        element={<MailModelsScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.mailModel.add.generate()}
        element={<MailModelScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.mailModel.details.generate(
          ":mailModelId",
        )}
        element={<MailModelScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.contacts.generate()}
        element={<ContactsScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.preferences.generate()}
        element={<PreferencesScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.cgu.generate()}
        element={<CguScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.users.generate()}
        element={<UsersScreen />}
      />
      <Route
        path={ROUTES.extranet.menu.offices.group.generate()}
        element={<GroupScreen />}
      />
      <Route
        path={ROUTES.extranet.transactions.signature.generate()}
        element={<SignatureScreen />}
      />
      <Route
        path={ROUTES.extranet.transactions.scellement.generate()}
        element={<ScellementScreen />}
      />
      <Route
        path={ROUTES.extranet.transactions.details.generate(":transactionId")}
        element={<TransactionScreen />}
      />
      <Route
        path={ROUTES.extranet.transactions.resetPositioning.generate(
          ":transactionId",
          ":reset",
        )}
        element={<PreLoadingResetSignaturePositioningScreen />}
      />
      <Route
        path={ROUTES.extranet.transactions.resetPositioning.generate(
          ":transactionId",
        )}
        element={<PreLoadingResetSignaturePositioningScreen />}
      />
      <Route
        path={ROUTES.extranet.transactions.positioning.generate()}
        element={<SignaturePositioningScreen />}
      />
      <Route
        path={ROUTES.extranet.transactions.process.generate(":transactionId")}
        element={<ProcessScreen />}
      />
      <Route
        path={ROUTES.extranet.signature.generate(":signatoryId")}
        element={<SignatorySignatureSuccessScreen />}
      />
      <Route
        path={ROUTES.extranet.officeTransfer.confirmation.generate(":shortcut")}
        element={<OfficeTransferScreen />}
      />
      <Route
        path={ROUTES.extranet.officeTransfer.confirmed.generate(":shortcut")}
        element={<OfficeTransferConfirmedScreen />}
      />
      <Route
        path={ROUTES.extranet.officeTransfer.refused.generate(":shortcut")}
        element={<OfficeTransferRefusedScreen />}
      />
      <Route
        path={ROUTES.extranet.officeTransfer.canceled.generate(":shortcut")}
        element={<OfficeTransferCanceledScreen />}
      />
      <Route
        path={ROUTES.extranet.editors.generate(
          ":idRequest",
          ":shortcut",
          ":type",
          ":token",
        )}
        element={<EditorTokenCallbackScreen />}
      />
      <Route
        path={ROUTES.extranet.editors.generate(
          ":idRequest",
          ":shortcut",
          ":type",
        )}
        element={<EditorTokenCallbackScreen />}
      />
      <Route
        path={ROUTES.extranet.error.generate()}
        element={<ErrorScreen />}
      />
      <Route path={ROUTES.extranet.home.generate()} element={<HomeScreen />} />
    </Route>
    <Route
      path="/"
      element={<Navigate to={ROUTES.extranet.home.generate()} />}
    />
  </>
);

export default coreRoutes;
